import { executeSearch, fetchMoreProducts, prepareForSearchWithQuery, promoteChildToParent, } from './search-actions.js';
import { commerceSearchReducer as commerceSearch } from './search-slice.js';
/**
 * Loads the commerce search reducer and returns the available search action creators.
 *
 * @param engine - The headless commerce engine.
 * @returns An object holding the search action creators.
 *
 * @group Actions
 * @category Search
 */
export function loadSearchActions(engine) {
    engine.addReducers({ commerceSearch });
    return {
        executeSearch,
        fetchMoreProducts,
        prepareForSearchWithQuery,
        promoteChildToParent,
    };
}
